/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IBlueprintSchemaValidationError } from "../Validator/IBlueprintSchemaValidator";
import { TGenericModelNode } from "../Schema/IModelNode";

/**
 * Runtime context
 */
export class RuntimeValidationError extends Error {
	public modelNode: TGenericModelNode;
	public validationErrors: IBlueprintSchemaValidationError[];

	public constructor(modelNode: TGenericModelNode, errors: IBlueprintSchemaValidationError[]) {
		super(`Validation error:\n${errors.map((e) => "- " + e.message).join("\n")}`);

		this.modelNode = modelNode;
		this.validationErrors = errors;
	}
}
